import React from 'react'
import {PaymentButton, PaymentNoPayment, PaymentPayIcon, PaymentSaveInfoContainer} from './style'
import {Box, Grid, Typography} from '@mui/material';
import SinglePaymentMethod from './SinglePaymentMethod';
import {determinePaymentImage} from "../../util/PaymentUtils";
import EmailVerifyToolTip from "../../components/notifications/EmailVerifyToolTip";
import {hasOwnerAccess} from "../../util/AccountUtils";

const BookingPaymentInfo = ({ account, paymentMethods, showPaymentModal, selectedPaymentMethod, setSelectedPaymentMethod }) => {

    return (
        <Box>
            <Grid container justifyContent='space-between' alignItems='center'>
                <Typography variant={'h5'} color={'textPrimary'}>
                    Pay With
                </Typography>
                <EmailVerifyToolTip
                    title={"Please verify your email address to add a payment method."}
                    isEmailVerified={account?.emailVerified}
                >
                  {hasOwnerAccess(account) &&
                  <PaymentButton onClick={showPaymentModal} variant='contained' color='secondary' disabled={!account.emailVerified}>
                    <PaymentPayIcon />
                    ADD PAYMENT
                  </PaymentButton>
                  }
                </EmailVerifyToolTip>
            </Grid>
            {paymentMethods?.length > 0 ? <PaymentSaveInfoContainer>
                {paymentMethods.map((paymentMethod) => {
                    return (
                        <SinglePaymentMethod
                          key={paymentMethod.id}
                          img={determinePaymentImage(paymentMethod)}
                          cardInfo={`...` + paymentMethod.lastFour + (paymentMethod.nickName ? ` (${paymentMethod.nickName})` : '')}
                          isSelect={selectedPaymentMethod === paymentMethod.id}
                          id={paymentMethod.id}
                          onClick={setSelectedPaymentMethod}
                        />
                    )
                })}
            </PaymentSaveInfoContainer> : <PaymentNoPayment>
                No payment method added yet
            </PaymentNoPayment>}

        </Box>
    )
}

export default BookingPaymentInfo
